import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    confirm(event: SubmitEvent): void {
        const form = event.currentTarget as HTMLFormElement;
        const message = form.dataset.confirmMessage;
        if (message && !window.confirm(message)) event.preventDefault();
    }
}
